/**
 * Jaarplanning actienamen + basis-% (1/2/3).
 * Geldig alleen woensdag (vol %) en donderdag (0,5 × %) Europe/Amsterdam.
 * Alleen PVC-vloeren en traprenovatie.
 */
(function (w) {
  'use strict';

  var TZ = 'Europe/Amsterdam';
  var WD = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

  var SCHEDULE = [
    { sm: 1, sd: 1, em: 1, ed: 31, name: 'Nieuwjaars Sale', pct: 3 },
    { sm: 2, sd: 1, em: 2, ed: 28, name: 'Vloerverwarming & Combi-Deals', pct: 1 },
    { sm: 3, sd: 1, em: 4, ed: 15, name: 'Voorjaars Woonweken & Paasshow', pct: 2 },
    { sm: 4, sd: 16, em: 5, ed: 31, name: 'Vakantiegeld Voordeelweken', pct: 2 },
    { sm: 6, sd: 1, em: 8, ed: 31, name: 'Magazijnopruiming', pct: 3 },
    { sm: 9, sd: 1, em: 9, ed: 30, name: 'Najaarscollectie', pct: 1 },
    { sm: 10, sd: 1, em: 10, ed: 31, name: 'Nationale Woonmaand Actie', pct: 3 },
    { sm: 11, sd: 1, em: 11, ed: 21, name: 'Klaar-voor-de-Kerst Garantie', pct: 1 },
    { sm: 11, sd: 22, em: 11, ed: 30, name: 'Black Friday Week', pct: 3 },
    { sm: 12, sd: 1, em: 12, ed: 31, name: 'Oudejaarssale', pct: 2 }
  ];

  function amsterdamParts(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    })
      .formatToParts(now)
      .forEach(function (p) {
        if (p.type !== 'literal') parts[p.type] = p.value;
      });
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second),
      isoWeekday: WD[parts.weekday] || 0
    };
  }

  function md(month, day) {
    return month * 100 + day;
  }

  function findCampaign(month, day) {
    var tm = md(month, day);
    var i;
    for (i = 0; i < SCHEDULE.length; i++) {
      var start = md(SCHEDULE[i].sm, SCHEDULE[i].sd);
      var end = md(SCHEDULE[i].em, SCHEDULE[i].ed);
      if (tm >= start && tm <= end) return SCHEDULE[i];
    }
    return null;
  }

  function weekdayPct(base, isoWeekday) {
    var n = Number(base) || 0;
    if (isoWeekday === 3) return n;
    if (isoWeekday === 4) return Math.round(n * 50) / 100;
    return 0;
  }

  function saleLabel(isoWeekday) {
    if (isoWeekday === 3) return 'Woon woensdag';
    if (isoWeekday === 4) return 'Woon woensdag after sale';
    return '';
  }

  function endOfAmsterdamDay(now) {
    var p = amsterdamParts(now);
    var key = p.year + '-' + p.month + '-' + p.day;
    var lo = now.getTime();
    var hi = lo + 36 * 3600 * 1000;
    while (hi - lo > 250) {
      var mid = Math.floor((lo + hi) / 2);
      var pm = amsterdamParts(new Date(mid));
      var k = pm.year + '-' + pm.month + '-' + pm.day;
      if (k === key) lo = mid;
      else hi = mid;
    }
    return new Date(lo);
  }

  function findState(now) {
    now = now || new Date();
    var p = amsterdamParts(now);
    if (p.isoWeekday !== 3 && p.isoWeekday !== 4) return null;
    var entry = findCampaign(p.month, p.day);
    if (!entry) return null;
    var pct = weekdayPct(entry.pct, p.isoWeekday);
    if (!(pct > 0)) return null;
    return {
      mode: 'active',
      entry: {
        sm: entry.sm,
        sd: entry.sd,
        em: entry.em,
        ed: entry.ed,
        name: entry.name,
        pct: pct,
        basePct: entry.pct
      },
      saleLabel: saleLabel(p.isoWeekday),
      target: endOfAmsterdamDay(now)
    };
  }

  function getActiveName(now) {
    var state = findState(now || new Date());
    return state && state.mode === 'active' && state.entry ? state.entry.name : '';
  }

  function getActivePct(now) {
    var state = findState(now || new Date());
    if (!state || !state.entry) return 0;
    return Number(state.entry.pct) || 0;
  }

  function getPctForName(name, now) {
    var want = String(name || '').trim().toLowerCase();
    if (!want) return 0;
    var state = findState(now || new Date());
    if (!state || !state.entry) return 0;
    if (String(state.entry.name).toLowerCase() !== want) return 0;
    return Number(state.entry.pct) || 0;
  }

  function getAllNames() {
    return SCHEDULE.map(function (entry) {
      return entry.name;
    });
  }

  function getCodeCandidates(config) {
    config = config || {};
    var list = [];
    var seen = {};
    var active = getActiveName(new Date());

    function add(code) {
      code = String(code || '').trim();
      if (!code) return;
      var key = code.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      list.push(code);
    }

    if (config.useCalendar !== false && active) add(active);
    if (config.manualCode) add(config.manualCode);
    return list;
  }

  w.UF_LF_ACTIE_SCHEDULE = SCHEDULE;
  w.UF_LF_ACTIE = {
    schedule: SCHEDULE,
    findCampaign: findCampaign,
    findState: findState,
    getActiveName: getActiveName,
    getActivePct: getActivePct,
    getPctForName: getPctForName,
    getAllNames: getAllNames,
    getCodeCandidates: getCodeCandidates,
    weekdayPct: weekdayPct,
    saleLabel: saleLabel
  };
})(window);
